import { useState } from "react";
import { Modal } from "./Modal";

interface IntroductionProps {
    isCompleted: () => void;
}

export function Introduction({ isCompleted }: IntroductionProps): JSX.Element {
    const [isModalOpen, setIsModalOpen] = useState(true);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => { setIsModalOpen(false); isCompleted(); }



    return (
        <Modal isOpen={isModalOpen} onClose={closeModal} title="Introduction">
            <div className="space-y-4 text-base">
                <div>
                    <h1 className="font-bold">
                        Background
                    </h1>
                    <p>
                        In the project "Data Matrix Pilotline POC 2021" an application for internal
                        use at Seco Tools in Fagersta was developed, and it was named HowRU.
                        During the project, all technicians in all process steps had the opportunity
                        to test the application and give feedback on the present (at that time) functionality.
                    </p>
                </div>
                <div>
                    <h1 className="font-bold">
                        Present state
                    </h1>
                    <p>
                        Today, the application for mobile devices has a variety of functions, including a ID-view for data matrix scanned insert, a machine view with digital twins for all process steps and an overview of the current situation with MIA (dispatch list). This Teams-application has only limited functionality so far, but can be extended as needed.
                    </p>
                </div>
                <div>
                    <h1 className="font-bold">
                        Feedback
                    </h1>
                    <p>
                        Your feedback on the application helps us identify areas for improvement and enhance the user experience. We value your insights and appreciate your contribution to shaping the final product.
                    </p>
                </div>
                <div>
                    <h1 className="font-bold">
                        Asset List
                    </h1>
                    <p>
                        On the right side of the interface, you will find a section labeled Assets. From this list, you can navigate to a specific Work center. Once you are on a Work center, you can click the three dots (…) located to the far right of the Work center’s name. This menu allows you to pin items to your Dashboard for quick access.
                    </p>
                </div>
                <div>
                    <h1 className="font-bold">
                        Dashboard
                    </h1>
                    <p>
                        The Dashboard displays all the items you have pinned from the Asset List. To remove an item, you can either click the Close (X) button directly on the Dashboard or unpin it from the Asset List by accessing the top of the list.
                    </p>
                </div>
                <div>
                    <h1 className="font-bold">
                        INCLOBOT
                    </h1>
                    <p>
                        Using INCLOBOT, you can ask questions and retrieve various datasets such as OEE, temperature, and other metrics for any Work center or machine. Additionally, you can perform comparisons between different machines to gain deeper insights.
                    </p>
                </div>
            </div>
        </Modal>
    );
};
